import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';

interface State {
	isWatchingUser: boolean;
}

export class ResetButton extends React.Component<{}, State> {
	constructor(props: Readonly<{}>) {
		super(props);

		this.state = {
			isWatchingUser: false
		};

		document.body.addEventListener('watching-user', (e) => this.setState({ isWatchingUser: (e as CustomEvent).detail.isWatchingUser }), false);
	}

	public render() {
		if (this.state.isWatchingUser) {
			return "";
		}

		return <button className='button reset-button' onClick={() => this.reset()}>
			<FontAwesomeIcon icon={faTrashAlt} />
		</button>
	}

	reset() {
		const elem = document.getElementById('renderCanvas');

		if (elem) {
			elem.dispatchEvent(new Event('reset'));
		}
	}
}